import { ModelInModelTreeInProcessEditor } from "../create-model-tree-for-porcess-editor-and-set-uuid/create-model-tree-for-porcess-editor-and-set-uuid";

export function findNodeAndParentInModelTreeInProcessEditor(
    modelTree: ModelInModelTreeInProcessEditor[],
    uuid: string,
    parent: ModelInModelTreeInProcessEditor | null = null
): { node: ModelInModelTreeInProcessEditor | null; parent: ModelInModelTreeInProcessEditor | null } {
  
    for (const node of modelTree) {
        if (node.uuid === uuid) {
            return { node, parent };
        }
        
        const found = findNodeAndParentInModelTreeInProcessEditor(node.children, uuid, node);
        if (found.node) return found;
    }

    return { node: null, parent: null };
}